import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});
  const [indianStates, setIndianStates] = useState([]);
  const [districtsByState, setDistrictsByState] = useState({});
  const [months, setMonths] = useState([]);
  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const [relationTypes, setRelationTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTemplates = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/templates`);
      setTemplates(response.data.templates || []);
      setFieldLabels(response.data.field_labels || {});
      setIndianStates(response.data.indian_states || []);
      setDistrictsByState(response.data.districts_by_state || {});
      setMonths(response.data.months || []);
      setDaysOfWeek(response.data.days_of_week || []);
      setRelationTypes(response.data.relation_types || []);
    } catch (error) {
      // /api/templates is feature-gated. Doc-team / custom users without the
      // 'templates' feature get a 403 here — that's expected. The metadata
      // they actually need (states, districts, education) is exposed on
      // /api/crm/meta. We swallow the error silently.
      const status = error?.response?.status;
      if (status && status !== 403 && status !== 401) {
        toast.error('Failed to load templates');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  return {
    templates,
    fieldLabels,
    indianStates,
    districtsByState,
    months,
    daysOfWeek,
    relationTypes,
    loading,
    refetch: fetchTemplates
  };
};
